import {
  Component, ContentChildren, Directive,
  EventEmitter,
  Input,
  Output, QueryList,
} from '@angular/core';
import {BaseView} from '../../view/base.view';

@Directive({
  selector: '[title]'
})
export class SummaryTitleProjectionDirective {}

@Directive({
  selector: '[badges]'
})
export class SummaryBadgeProjectionDirective {}

@Component({
  selector: 'app-summary',
  template: `
      <div class="summary" (click)="click()" [style]="clickRedirectTo ? 'cursor: pointer;' : ''">
        <div style="display: flex;" class="gap-5">
          <app-button (click)="expanded=false" *ngIf="expandable && expanded" [withMargin]="false" size="small"
                      [withPadding]="false" class="ion-no-margin ion-margin-end" iconName="chevron-down"></app-button>
          <app-button (click)="expandedEvent.emit();expanded=true" *ngIf="expandable && !expanded" [withMargin]="false" size="small"
                      [withPadding]="false" class="ion-no-margin ion-margin-end" iconName="chevron-right"></app-button>
          <div *ngIf="iconName" class="flex-shrink-0 flex-grow-0 d-flex align-items-center">
            <i-tabler [name]="iconName" class="icon-20 d-flex"></i-tabler>
          </div>
          <div style="flex-grow: 1;">
            <div class="summary-title d-flex gap-5" *ngIf="titles?.length > 0 || badges?.length > 0">
              <h5 class="f-s-13 f-w-500 d-block mat-subtitle-2 m-0 m-b-4 m-t-8 flex-grow-0 flex-shrink-1">
                <ng-content select="[title]"></ng-content>
              </h5>
              <div class="flex-grow-0 flex-shrink-0">
                <app-badge [label]="badgeLabel"></app-badge>
                <ng-content select="[badges]"></ng-content>
              </div>
              
            </div>
            <div class="d-flex gap-4 align-items-center flex-wrap">
              <ng-content select="[content]"></ng-content>
            </div>
            <ng-container *ngIf="expandable && expanded">
              <div>
                <div class="f-s-12 mat-body-2">
                  <ng-content select="[expandedContent]"></ng-content>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
  `,
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent extends BaseView{

  @Input() badgeLabel: string;
  @Input() clickRedirectTo: string;
  @Input() expandable = false;
  @Input() expanded = false;
  @Input() iconName: string;
  @Output() expandedEvent = new EventEmitter<void>();
  @Output() clickedEvent = new EventEmitter<void>();

  @ContentChildren(SummaryTitleProjectionDirective) titles!: QueryList<SummaryTitleProjectionDirective>;
  @ContentChildren(SummaryBadgeProjectionDirective) badges!: QueryList<SummaryBadgeProjectionDirective>;

  constructor() {
    super();
  }

  click(){
    if (this.clickRedirectTo) {
      this.redirectTo(this.clickRedirectTo);
    }
    this.clickedEvent.emit();
  }
}
